// Full Job_Form.jsx with Creatable skills input

import React, { useState, useEffect, useCallback } from "react";
import Creatable from "react-select/creatable";
import TableInputs from "../../components/tableinputs/TableInputs";
import Select from "react-select";
import Buttons from "../../components/buttons/Buttons";
import ModalComponent from "../../components/modalcomponent/ModalComponent";
import Customstyles from "../../pages/joinourteam/JoinOurTeam.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { AxiosInstance } from "../../axios";

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

function Job_Form() {
  const navigate = useNavigate();
  const location = useLocation();
  const jobId = location.state?.jobId;

  const [formData, setFormData] = useState({
    role: "",
    location: "",
    department_id: "",
    min_experience: "",
    max_experience: "",
    work_arrangement: "",
    skill_ids: [], // Array of { tag_id, tag_name }
    description: "",
  });

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [skillOptions, setSkillOptions] = useState([]);
  const [workArrangementOptions, setWorkArrangementOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState({ title: "", body: "" });
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalJobDetails, setOriginalJobDetails] = useState(null);

  useEffect(() => {
    AxiosInstance.get("/api/joinourteam/job/departmentlist").then((res) => {
      if (res.data.status) {
        setDepartmentOptions(
          res.data.Department.map((dept) => ({
            label: dept.name,
            value: dept.id,
          })),
        );
      }
    });

    AxiosInstance.get("/api/joinourteam/job/taglist").then((res) => {
      if (res.data.status) {
        setSkillOptions(
          res.data.tag.map((skill) => ({ label: skill.name, value: skill.id })),
        );
      }
    });

    setWorkArrangementOptions([
      { label: "Remote", value: 2 },
      { label: "On-site", value: 1 },
      { label: "Hybrid", value: 3 },
    ]);
  }, []);

  useEffect(() => {
    if (jobId) {
      setIsEditMode(true);
      const fetchJobDetails = async () => {
        try {
          const res = await AxiosInstance.post("/api/joinourteam/job/view", {
            job_id: jobId,
          });
          if (res.data.status && res.data.job) {
            const job = res.data.job;
            setOriginalJobDetails(job);
            let min_exp = "";
            let max_exp = "";
            if (typeof job.yearof_experience === "string") {
              const expParts = job.yearof_experience.split("-");
              min_exp = expParts[0] || "";
              max_exp = expParts[1] || "";
            }

            const fetchedSkillIds = [];
            if (
              job.tag_name &&
              typeof job.tag_name === "string" &&
              skillOptions.length > 0
            ) {
              const tags = job.tag_name
                .split(",")
                .map((tag) => tag.trim().toLowerCase());
              tags.forEach((tagName) => {
                const skill = skillOptions.find(
                  (opt) => opt.label.toLowerCase() === tagName,
                );
                if (skill) {
                  fetchedSkillIds.push({
                    tag_id: skill.value,
                    tag_name: skill.label,
                  });
                } else {
                  fetchedSkillIds.push({ tag_id: "", tag_name: tagName });
                }
              });
            }

            setFormData({
              role: job.role || "",
              location: job.location || "",
              department_id: job.department_id ? String(job.department_id) : "",
              min_experience: min_exp,
              max_experience: max_exp,
              work_arrangement: job.work_arrangement
                ? String(job.work_arrangement)
                : "",
              skill_ids: fetchedSkillIds,
              description: job.description || "",
            });
          }
        } catch (err) {
          navigate("/admin/job-create");
        }
      };
      if (skillOptions.length > 0) fetchJobDetails();
    } else {
      setIsEditMode(false);
      setFormData({
        role: "",
        location: "",
        department_id: "",
        min_experience: "",
        max_experience: "",
        work_arrangement: "",
        skill_ids: [],
        description: "",
      });
      setOriginalJobDetails(null);
    }
  }, [jobId, navigate, skillOptions]);

  // const validateField = useCallback((name, value) => {
  //   const alphaRegex = /^[A-Za-z\s]+$/; // Only letters and spaces
  //   const numericRegex = /^\d+$/; // Only digits

  //   if (name === "skill_ids" && value.length === 0)
  //     return "At least one skill is required.";

  //   if (name === "role") {
  //     if (!value) return "Job role is required.";
  //     if (!alphaRegex.test(value))
  //       return "Role must contain only letters and spaces.";
  //   }

  //   if (name === "location" && !value) return "Location is required.";

  //   if (name === "department_id" && !value) return "Department is required.";

  //   if (name === "work_arrangement" && !value)
  //     return "Work arrangement is required.";

  //   if (name === "description" && !value) return "Job description is required.";

  //   if (name === "min_experience") {
  //     if (value === "") return "Minimum experience is required.";
  //     if (!numericRegex.test(value))
  //       return "Minimum experience must be a number.";
  //   }

  //   if (name === "max_experience") {
  //     if (value === "") return "Maximum experience is required.";
  //     if (!numericRegex.test(value))
  //       return "Maximum experience must be a number.";
  //   }

  //   return "";
  // }, []);

  const validateField = useCallback((name, value) => {
    const alphaRegex = /^[A-Za-z\s]+$/; // Only letters and spaces
    const numericRegex = /^\d+$/; // Only digits
    const emojiRegex = /[\p{Extended_Pictographic}]/u; // Emoji detection

    const trimmedValue = typeof value === "string" ? value.trim() : value;

    if (name === "skill_ids" && value.length === 0)
      return "At least one skill is required.";

    if (name === "role") {
      if (!trimmedValue) return "Job role is required.";
      if (emojiRegex.test(trimmedValue))
        return "Emojis are not allowed in role.";
      if (!alphaRegex.test(trimmedValue))
        return "Role must contain only letters and spaces.";
    }

    if (name === "location") {
      if (!trimmedValue) return "Location is required.";
      if (emojiRegex.test(trimmedValue))
        return "Emojis are not allowed in location.";
    }

    if (name === "department_id" && !value) return "Department is required.";

    if (name === "work_arrangement" && !value)
      return "Work arrangement is required.";

    if (name === "description") {
      if (!trimmedValue) return "Job description is required.";
    }

    if (name === "min_experience") {
      if (value === "") return "Minimum experience is required.";
      if (!numericRegex.test(value))
        return "Minimum experience must be a number.";
    }

    if (name === "max_experience") {
      if (value === "") return "Maximum experience is required.";
      if (!numericRegex.test(value))
        return "Maximum experience must be a number.";
    }

    return "";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      const error = validateField(key, value);
      if (error) newErrors[key] = error;
    });
    if (formData.min_experience && formData.max_experience) {
      const minExp = parseInt(formData.min_experience);
      const maxExp = parseInt(formData.max_experience);

      if (minExp > maxExp) {
        newErrors.max_experience =
          "Max experience cannot be less than Min experience.";
      } else if (minExp === maxExp) {
        newErrors.min_experience = "Min and Max experience cannot be the same.";
        newErrors.max_experience = "Min and Max experience cannot be the same.";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const user_type = getCookie("user_type") || 1;
    const user_id = getCookie("user_id") || "";
    const basePayload = {
      user_type: parseInt(user_type),
      role: formData.role,
      department_id: parseInt(formData.department_id),
      location: formData.location,
      yearof_experience: `${formData.min_experience}-${formData.max_experience}`,
      description: formData.description,
      work_arrangement: parseInt(formData.work_arrangement),
      tag: formData.skill_ids,
    };

    let apiEndpoint = "";
    let payload = {};

    if (isEditMode && jobId) {
      payload = {
        ...originalJobDetails,
        ...basePayload,
        job_id: jobId,
        updated_by: user_id,
        job_status: 0,
        approval_status: 0,
        is_active: originalJobDetails?.is_active || 1,
        deleted: originalJobDetails?.deleted || 0,
      };
      apiEndpoint = "/api/joinourteam/job/update";
    } else {
      payload = {
        ...basePayload,
        created_by: user_id,
        created_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        is_active: 1,
        deleted: 0,
        job_status: 0,
        approval_status: 0,
      };
      apiEndpoint = "/api/joinourteam/job/create";
    }

    try {
      const res = await AxiosInstance.post(apiEndpoint, payload);
      setModalMessage({
        title: res.data.status ? "Success" : "Failed",
        body:
          res.data.message ||
          (res.data.status ? "Operation successful" : "Something went wrong"),
      });
      setOpen(true);
      if (res.data.status) {
        setFormData({
          role: "",
          location: "",
          department_id: "",
          min_experience: "",
          max_experience: "",
          work_arrangement: "",
          skill_ids: [],
          description: "",
        });
        setErrors({});
      }
    } catch (err) {
      setModalMessage({ title: "Error", body: "Failed to submit form." });
      setOpen(true);
    }
  };

  const handleModalClose = () => {
    setOpen(false);
    navigate("/admin/join-our-team");
  };

  return (
    <div className="container-fluid pt-3">
      {isEditMode ? (
        <ModalComponent
          show={open}
          onHide={handleModalClose}
          title="Job updated Successfully"
          bodyText="The job details have been updated successfully and are now pending Super Admin approval. Once approved, the changes will be reflected in the User Side listings. You can view the job status in the Job Listings page."
          buttontext="OK"
        />
      ) : (
        <ModalComponent
          show={open}
          onHide={handleModalClose}
          title="Job Created Successfully"
          bodyText="The new job posting has been created successfully and is pending Super Admin approval. Once approved, it will be visible in the User Side listings. You can view the job status in the Job Listings page."
          buttontext="OK"
        />
      )}
      <form onSubmit={handleSubmit}>
        <div className={`card p-4 ${Customstyles.customCard}`}>
          <div className="row">
            <div className="col-md-6 mb-2">
              <TableInputs
                label="Role"
                name="role"
                placeholder="Enter job role"
                value={formData.role}
                onChange={handleChange}
              />
              {errors.role && (
                <span className="custom_error">{errors.role}</span>
              )}
            </div>
            <div className="col-md-6 mb-2">
              <TableInputs
                label="Location"
                name="location"
                placeholder="Enter job location"
                value={formData.location}
                onChange={handleChange}
              />
              {errors.location && (
                <span className="custom_error">{errors.location}</span>
              )}
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Work Arrangement</label>
              <Select
                classNamePrefix="select"
                className="basic-single"
                name="work_arrangement"
                options={workArrangementOptions}
                value={workArrangementOptions.find(
                  (opt) => opt.value === parseInt(formData.work_arrangement),
                )}
                onChange={(selected) => {
                  setFormData((prev) => ({
                    ...prev,
                    work_arrangement: selected?.value || "",
                  }));
                  setErrors((prev) => ({ ...prev, work_arrangement: "" }));
                }}
                placeholder="Select work arrangement"
                styles={{
                  control: (base) => ({ ...base, minHeight: 40 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {errors.work_arrangement && (
                <span className="custom_error">{errors.work_arrangement}</span>
              )}
            </div>
            <div className="col-md-6 mb-2">
              <label className="form-label">Total Experience</label>
              <div className="row">
                <div className="col-6">
                  <TableInputs
                    name="min_experience"
                    type="select"
                    value={formData.min_experience}
                    onChange={handleChange}
                    options={[...Array(11)].map((_, i) => ({
                      label: i === 10 ? "10+" : `${i}`,
                      value: `${i}`,
                    }))}
                    placeholder="Min Year "
                  />
                  {errors.min_experience && (
                    <span className="custom_error">
                      {errors.min_experience}
                    </span>
                  )}
                </div>
                <div className="col-6">
                  <TableInputs
                    name="max_experience"
                    type="select"
                    value={formData.max_experience}
                    onChange={handleChange}
                    options={[...Array(11)].map((_, i) => ({
                      label: i === 10 ? "10+" : `${i}`,
                      value: `${i}`,
                    }))}
                    placeholder="Max Year"
                  />
                  {errors.max_experience && (
                    <span className="custom_error">
                      {errors.max_experience}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label">Skills (Tags)</label>
              <Creatable
                isMulti
                classNamePrefix="select"
                className="basic-multi-select"
                name="skills"
                placeholder="Select or enter new skill(s)..."
                value={formData.skill_ids.map((skill) => ({
                  label: skill.tag_name,
                  value: skill.tag_id || skill.tag_name,
                }))}
                // onChange={(selectedOptions) => {
                //   const updatedSkills = selectedOptions.map((opt) => {
                //     const existing = skillOptions.find(
                //       (s) => s.value === opt.value
                //     );
                //     return {
                //       tag_id: existing ? existing.value : "",
                //       tag_name: opt.label,
                //     };
                //   });
                //   setFormData((prev) => ({
                //     ...prev,
                //     skill_ids: updatedSkills,
                //   }));
                //   setErrors((prev) => ({ ...prev, skill_ids: "" }));
                // }}
                onChange={(selectedOptions) => {
                  const emojiRegex = /[\p{Extended_Pictographic}]/u;

                  // Check if ANY selected option label contains emoji
                  const hasEmoji = selectedOptions.some((opt) =>
                    emojiRegex.test(opt.label),
                  );

                  if (hasEmoji) {
                    setErrors((prev) => ({
                      ...prev,
                      skill_ids: "Emojis are not allowed in skills",
                    }));
                    return; // Stop updating state
                  }

                  setErrors((prev) => ({ ...prev, skill_ids: "" }));

                  const updatedSkills = selectedOptions.map((opt) => {
                    const existing = skillOptions.find(
                      (s) => s.value === opt.value,
                    );
                    return {
                      tag_id: existing ? existing.value : "",
                      tag_name: opt.label,
                    };
                  });

                  setFormData((prev) => ({
                    ...prev,
                    skill_ids: updatedSkills,
                  }));
                }}
                options={skillOptions}
                formatCreateLabel={(inputValue) => `Add New: "${inputValue}"`}
                isClearable={false}
                styles={{
                  control: (base) => ({ ...base, minHeight: 40 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {errors.skill_ids && (
                <span className="custom_error">{errors.skill_ids}</span>
              )}
            </div>

            <div className="col-md-6 mb-2">
              <label className="form-label">Department</label>
              <Select
                classNamePrefix="select"
                className="basic-single"
                name="department_id"
                options={departmentOptions}
                value={departmentOptions.find(
                  (opt) => opt.value === parseInt(formData.department_id),
                )}
                onChange={(selected) => {
                  setFormData((prev) => ({
                    ...prev,
                    department_id: selected?.value || "",
                  }));
                  setErrors((prev) => ({ ...prev, department_id: "" }));
                }}
                placeholder="Select Department"
                styles={{
                  control: (base) => ({ ...base, minHeight: 40 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {errors.department_id && (
                <span className="custom_error">{errors.department_id}</span>
              )}
            </div>
            <div className="col-md-12 mb-2">
              <TableInputs
                label="Job Description"
                name="description"
                type="textarea"
                placeholder="Enter job description"
                value={formData.description}
                onChange={handleChange}
              />
              {errors.description && (
                <span className="custom_error">{errors.description}</span>
              )}
            </div>
            <div className="row mt-3">
              <div className="col-md-6 d-flex justify-content-end">
                <Buttons
                  type="button"
                  text="Cancel"
                  onClick={() => navigate("/admin/join-our-team")}
                  variant="secondary"
                />
              </div>
              <div className="col-md-6 d-flex justify-content-start">
                <Buttons
                  type="submit"
                  text={isEditMode ? "Update" : "Submit"}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Job_Form;
